goog.provide("shadow.js.shim.module$date_fns$differenceInMilliseconds$default");
shadow.js.shim.module$date_fns$differenceInMilliseconds$default = esm_import$date_fns$differenceInMilliseconds.default;
